import React from 'react';
import styled from 'styled-components';
import { Page } from '/imports/ui/Page';
import { PageBody } from '/imports/ui/PageBody';
import { css } from '/imports/ui/css';
import { strings } from '/imports/strings';

const QuickbooksConnectedPageStyled = styled(Page)`
  .result { max-width: 34rem; margin: 4rem auto; text-align: center; }
  .result h1 { font-weight: normal; margin-bottom: 0.5rem; }
  .result .detail { color: ${css.grey3}; }
`;

/**
 * Where Intuit's callback lands the user.
 *
 * PUBLIC on purpose: a shareable connect link is completed by whoever holds the QuickBooks login —
 * often an accountant with no Luminia account — and an authenticated route would bounce them to
 * /login without ever telling them whether it worked.
 */
export const QuickbooksConnectedPage = () => {
  const result = new URLSearchParams(window.location.search).get('result');
  const message = result === 'connected' ? strings.QuickbooksConnected()
    : result === 'denied' ? strings.QuickbooksDenied()
      : result === 'expired' ? strings.QuickbooksLinkExpired()
        : strings.QuickbooksFailed();
  return (
    <QuickbooksConnectedPageStyled>
      <PageBody>
        <div className="result">
          <h1>QuickBooks</h1>
          <div className="detail">{message}</div>
        </div>
      </PageBody>
    </QuickbooksConnectedPageStyled>
  );
};
